export const PLACE_CALL = "PLACE_CALL";
export const GET_CALL_STATUS = "GET_CALL_STATUS";
export const END_CALL = "END_CALL";
export const GET_RECORDING = "GET_RECORDING";
export const GET_JOBS = "GET_JOBS";
export const GET_DOCTOR_LOGS = "GET_DOCTOR_LOGS";
export const GET_BILLING_LOGS = "GET_BILLING_LOGS";
export const IMPORT_CALL = "IMPORT_CALL";
export const GET_TRANSCRIPT = "GET_TRANSCRIPT";
export const RESET_CALL_RESULT = "RESET_CALL_RESULT";

const ACTION_LOADER = "AI_VERIFICATION_CALL_ACTION_LOADER";
const SET_CALL_RESULT = "SET_CALL_RESULT";
const SET_JOBS = "SET_JOBS";
const SET_DOCTOR_LOGS = "SET_DOCTOR_LOGS";
const SET_BILLING_LOGS = "SET_BILLING_LOGS";
const SET_TRANSCRIPT = "SET_TRANSCRIPT";
const SET_RECORDING_URL = "SET_RECORDING_URL";

export const initialState = {
  callResult: null,
  // Added for bulk-calling multiple doctors at once (see
  // BulkVerifyCallModal.jsx). callResult itself stays exactly as it
  // was — a single shared slice — since the existing single-call
  // AiVerifyCallButton.jsx already depends on that shape and works
  // correctly. This is purely additive: every SET_CALL_RESULT also
  // files into its own job's slot here, so N calls polling
  // concurrently can't ever overwrite each other's status the way
  // they would relying on callResult alone.
  callResultsByJobId: {},
  jobs: [],
  // keyed by the phone number that was requested — several ProviderCards
  // can be on screen at once, each asking for a different doctor
  doctorLogsByPhone: {},
  billingLogs: [],
  transcriptsByJobId: {},
  recordingUrlsByJobId: {},
  loadingState: false,
};

export const placeCall = (payload) => ({ type: PLACE_CALL, payload });
export const getCallStatus = (payload) => ({ type: GET_CALL_STATUS, payload });
export const endCall = (payload) => ({ type: END_CALL, payload });
export const getRecording = (payload) => ({ type: GET_RECORDING, payload });
export const getJobs = () => ({ type: GET_JOBS });
export const getDoctorLogs = (payload) => ({ type: GET_DOCTOR_LOGS, payload });
export const getBillingLogs = () => ({ type: GET_BILLING_LOGS });
export const importCall = (payload) => ({ type: IMPORT_CALL, payload });
export const getTranscript = (payload) => ({ type: GET_TRANSCRIPT, payload });
export const resetCallResult = () => ({ type: RESET_CALL_RESULT });

export const setLoaderState = (loadingState) => ({
  type: ACTION_LOADER,
  loadingState,
});
export const setCallResult = (payload) => ({ type: SET_CALL_RESULT, payload });
export const setJobs = (payload) => ({ type: SET_JOBS, payload });
export const setDoctorLogs = (payload) => ({ type: SET_DOCTOR_LOGS, payload });
export const setBillingLogs = (payload) => ({ type: SET_BILLING_LOGS, payload });
export const setTranscript = (payload) => ({ type: SET_TRANSCRIPT, payload });
export const setRecordingUrl = (payload) => ({
  type: SET_RECORDING_URL,
  payload,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_LOADER:
      return { ...state, loadingState: action.loadingState };
    case SET_CALL_RESULT:
      return {
        ...state,
        callResult: action.payload,
        callResultsByJobId: action.payload?.jobId
          ? { ...state.callResultsByJobId, [action.payload.jobId]: action.payload }
          : state.callResultsByJobId,
      };
    case RESET_CALL_RESULT:
      return { ...state, callResult: null };
    case SET_JOBS:
      return { ...state, jobs: action.payload };
    case SET_DOCTOR_LOGS:
      return {
        ...state,
        doctorLogsByPhone: {
          ...state.doctorLogsByPhone,
          [action.payload.phoneNumber]: action.payload.items,
        },
      };
    case SET_BILLING_LOGS:
      return { ...state, billingLogs: action.payload };
    case SET_TRANSCRIPT:
      return {
        ...state,
        transcriptsByJobId: {
          ...state.transcriptsByJobId,
          [action.payload.jobId]: {
            fullTranscript: action.payload.fullTranscript,
            dtmfPresses: action.payload.dtmfPresses,
          },
        },
      };
    case SET_RECORDING_URL:
      return {
        ...state,
        recordingUrlsByJobId: {
          ...state.recordingUrlsByJobId,
          [action.payload.jobId]: action.payload.url,
        },
      };
    default:
      return state;
  }
};